import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import Helper from "../../Helper";

interface Props {
    project: any;
    disabled?: boolean;
    className?: string;
    onClick?(): void;
    activated?: boolean;
}

export const IntegrationIcon: React.FC<Props> = (props) => {
    const [iconSource, setIconSource] = React.useState<string>("");

    useEffect(() => {
        if (!props.project) return;

        const validSources = ["procore", "procore_sandbox", "autodesk_construction"];
        const source =
            [
                props.project.activities_integration_source,
                props.project.submittals_integration_source,
                props.project.integration_source,
            ].find((src) => validSources.includes(src)) || "unset";

        const isDisabled = props.disabled || !props.activated;

        switch (source) {
            case "procore":
            case "procore_sandbox":
                setIconSource(isDisabled ? "/img/png/Procore_Icon_Disabled.png" : "/img/png/Procore_Icon.png");
                break;
            case "autodesk_construction":
                setIconSource(
                    isDisabled ? "/img/png/Autodesk_Build_Icon_Disabled.png" : "/img/png/Autodesk_Build_Icon.png"
                );
                break;
            default:
                setIconSource("");
                break;
        }
    }, [props.project, props.disabled, props.activated]);

    return iconSource && iconSource.length > 0 ? (
        <img src={iconSource} className={Helper.classNames("inline w-5", props.className)} onClick={props.onClick} />
    ) : (
        <div className="invisible" onClick={() => !props.disabled && props.onClick && props.onClick()}>
            <FontAwesomeIcon icon={faQuestion} className="w-5" />
        </div>
    );
};

export default IntegrationIcon;
